module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("1. SALAMIS, 480 BCE")])])]), _c('br'), _vm._v("Greek Audacity and Courage Defy the World’s Greatest Empire")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter02"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("2. ISSUS, 333 BCE")])])]), _c('br'), _vm._v("Alexander the Great Leads a Martial Storm into Mighty Persia")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("3. CANNAE, 216 BCE")])])]), _c('br'), _vm._v("Hannibal’s Masterpiece Thrashes Rome and Creates a Legend")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("4. CARRHAE, 53 BCE")])])]), _c('br'), _vm._v("Roman Arms Become Trapped Between the Scorching Sun and the Wrath of Parthia")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("5. ALESIA, 52 BCE")])])]), _c('br'), _vm._v("Caesar Shows His Enemies the Meaning of Roman Tenacity")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("6. TRICAMARUM, 533")])])]), _c('br'), _vm._v("Byzantium’s Finest Take on the Germanic Corsairs of North Africa")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("7. AGINCOURT, 1415")])])]), _c('br'), _vm._v("French Chivalry Endures the Flight of the Bodkins on St. Crispin’s Day")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("8. NARVA, 1700")])])]), _c('br'), _vm._v("A King’s Coming of Age Meets Sweden’s Finest Hour")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("9. LEUTHEN, 1757")])])]), _c('br'), _vm._v("Frederick the Great Steals Victory from the Jaws of Defeat")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("10. AUERSTADT, 1806")])])]), _c('br'), _vm._v("France’s Iron Marshal Avenges the Disaster of Rossbach")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("11. CHANCELLORSVILLE, 1863")])])]), _c('br'), _vm._v("Hooker Came, He Saw, He Got Conquered")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("12. RORKE’S DRIFT, 1879")])])]), _c('br'), _vm._v("Modern Arms and Raw Nerve Achieve the Incredible")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("13. TANNENBERG, 1914")])])]), _c('br'), _vm._v("Russia Is Impaled on the Spike of the Pickelhaube")]), _vm._v(" "), _c('p', {
    staticClass: "chaptoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("14. SINGAPORE, 1942")])])]), _c('br'), _vm._v("A Brilliant Japanese Gambit Steals the Gibraltar of the East")]), _vm._v(" "), _c('p', {
    staticClass: "tocback1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e656ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 63
// module chunks = 0